export default "__VITE_ASSET__1c400c8e__"